export const Link = {
  baseStyle: ({ theme }) => ({
    color: theme.colors.link.normal,
    _hover: {
      color: theme.colors.link.hover,
    },
  }),
};
